import React, { useEffect } from "react";
import { SourceDto, SpellDto } from "../../../Types/ApiTypes";
import { getAllSources, getAllSpells } from "../../../Utils/LocalApi";
// import { useTranslation } from "react-i18next";
// import i18n from "../../../i18n";
import SpellTableComponent from "./SpellTableComponent";

const SpellListComponent = ()=>{
    // const [isModalOpen, setIsModalOpen] = useState(false);
    // const { t } = useTranslation();

    const [allSpells, setAllSpells] = React.useState<SpellDto[]>([]);
    useEffect(() => {
        getAllSpells().then((value) => {
            let newSpells = [] as SpellDto[];
            value.forEach((element: SpellDto) => {
                newSpells.push(element);
                setAllSpells([...newSpells]);
            });
        });
    },[]);

    const [allSources, setAllSources] = React.useState<SourceDto[]>([]);
    useEffect(() => {
        getAllSources().then((value) => {
            setAllSources(value);
        });
    },[]);
    
    
    return (
        <div className="">
            <div className="d-flex black justify-content-between px-4 py-2 header navbar text-white bg-dark">
            </div>
            <SpellTableComponent
                allSpells = {allSpells}
                allSources = {allSources}
                setAllSpells = {setAllSpells}
            ></SpellTableComponent>
        </div>
    )
}
export default SpellListComponent;
